module.exports = __webpack_public_path__ + "cdb0062838530082085a0dd3e2f0b1d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/5.jpg
// module id = 230
// module chunks = 0